import React from 'react';
import classNames from "classnames";
import numbro from 'numbro';

// plugin that creates slider
import nouislider from "nouislider";

// react plugin for creating charts
import ChartistGraph from "react-chartist";
import Chartist from 'chartist';
import tooltip from 'chartist-plugin-tooltips';

// @material-ui/core components
import Icon from "@material-ui/core/Icon";
import withStyles from "@material-ui/core/styles/withStyles";
import IconButton from '@material-ui/core/IconButton';
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";


// @material-ui/icons
import BarChartIcon from '@material-ui/icons/BarChart';
import ShortTextIcon from '@material-ui/icons/ShortText';
import Sync from '@material-ui/icons/Sync';
import SyncDisabled from '@material-ui/icons/SyncDisabled';

// Core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import dashGeneralPageStyle from "assets/jss/prehnit/views/dashGeneralPageStyle.jsx";

import { withNamespaces } from "react-i18next";
import { Context } from "Context.jsx";

import CLCColors from "assets/data/clc_colors.js";
import { Typography } from '@material-ui/core';

import CLCChartZoom from "components/CLCDataCards/CLCChartZoom";

// HTML Label plugin
Chartist.plugins = Chartist.plugins || {};
Chartist.plugins.ctHtmlLabels = function (options) {
  return function (chart) {
    chart.on('draw', function (context) {
      if (context.type === 'label') {
        // Best to combine with something like sanitize-html
        context.element.empty()._node.innerHTML = context.text;
      }
    });
  }
}


class CLCDistChartCard extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = {
      chart_width: "",
      high_ha: 10000
    }

    this.maxY_ha = undefined;
    this.minY_ha = undefined;

    this.handleSort = this.handleSort.bind(this);
    this.handleZoom = this.handleZoom.bind(this);
    this.handleSync = this.handleSync.bind(this);
    this.handleZoomMount = this.handleZoomMount.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    window.addEventListener('resize', this.updateChartSize.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateChartSize.bind(this))
    this._isMounted = false;
  }

  updateChartSize() {
    let el = document.getElementById(this.props.id);
    if (el && this._isMounted) {
      this.setState({
        chart_width: el.offsetWidth
      });
    }
  }

  chartListener() {
    return {
      draw: function (data) {
        if (data.type === "label") {
        }
        if (data.type === "bar") {
          let meta = data.series[data.index].meta
          let parts = meta.split(';');
          let clc_code = parts[0];
          let clc_color = CLCColors[clc_code];
          data.element.attr({
            style: 'stroke: ' + clc_color + '; stroke-width:10px;'
          });
        }
        if (data.type === "grid") {
          data.element.attr({
            style: 'stroke: rgba(0,0,0,.2); stroke-width:1px; stroke-dasharray: 2px;'
          })
        }
      }
    }
  }


  chartOptions(width, unit) {
    const { t, data } = this.props;

    let axisYhigh = this.calcAxisYHigh(this.props.zoom);

    if (!width) {
      let el = document.getElementById(this.props.id);
      if (el) {
        width = el.offsetWidth;
      }
    }

    return {
      axisX: {
        showGrid: false,
        labelInterpolationFnc: function (value, index, funcData) {
          return '<span class="ct-label ct-horizontal ct-end ct-rotate" style="width: 28px; height: 12px; margin:0 auto; font-size:.75rem; color: rgba(0,0,0,.7);">'
            + value
            + '<div style="background-color:' + CLCColors[value]
            + "; margin-left: 3px"
            + "; width: 10px"
            + "; height: 10px"
            + "; min-height: 10px"
            + "; min-width: 10px"
            + "; border: 1px solid #ccc"
            + '"></div>'
            + '</span>'
        }
      },
      axisY: {
        offset: 100,
        low: 0,
        high: axisYhigh ? unit.transform(axisYhigh) : undefined,
        labelInterpolationFnc: function (value, index, data) {
          let suffix = "";
          if (index === data.length - 1 && axisYhigh) {
            suffix = " +"
          }
          let num = numbro(value).format({ mantissa: 2 });
          if (value > 10) {
            num = numbro(value).format({ mantissa: 0 });
          }

          return '<span class="ct-label ct-vertical ct-start"  style="height: 100%; width: 100%; font-size:.75rem; color: rgba(0,0,0,.7); display:flex; -webkit-box-align: flex-end; -ms-flex-align: flex-end;align-items: flex-end;-webkit-box-pack: flex-end;-webkit-justify-content: flex-end;-ms-flex-pack: flex-end;justify-content: flex-end;text-align: right;text-anchor: end;">' + num + suffix + '</span>';
        }.bind(this)
      },
      height: "200px",
      width: width,
      plugins: [
        Chartist.plugins.tooltip({
          metaIsHTML: false,
          tooltipFnc: function (meta, value) {
            if (meta) {
              let parts = meta.split(';')
              let code = parts[0];
              let unit = parts[1];
              return t("map:code") + ": " + code + "<br/>"
                + t("clc:" + code) + "<br/>"
                + t("map:area") + ": " + numbro(value * 100).divide(100).format() + " " + unit;
            } else {
              return numbro(value * 100).divide(100).format();
            }
          },
        }),
        Chartist.plugins.ctHtmlLabels()
      ]
    }
  }

  filterData(data, col, id) {
    return data.filter(row => {
      return row[col] == id; //must be loose equal ('==')
    });
  }

  chartData(unit) {

    // let data = this.filterData(this.props.allData, this.props.filterColumnName, this.props.filterId);
    let data = this.props.data;
    data.sort(this.props.sortFunc);

    let labels = [];
    let series = [];

    this.minY_ha = undefined;
    this.maxY_ha = 0;

    if (data) {
      for (let i = 0; i < data.length; i++) {
        let el = data[i];
        if (el.kod_3) {
          labels.push(el.kod_3);
        }
        if (el.pov_3_ha) {
          let val = numbro(unit.transform(el.pov_3_ha) * 100).divide(100).value()
          let val_ha = numbro(el.pov_3_ha * 100).divide(100).value();
          if (this.minY_ha === undefined || val_ha < this.minY_ha) {
            this.minY_ha = val_ha;
          }
          if (val_ha > this.maxY_ha) {
            this.maxY_ha = val_ha;
          }
          series.push({ meta: el.kod_3 + ";" + unit.short, value: val });
        }
      }

    }

    return {
      labels: labels,
      series: [series]
    };
  }

  footerData(unit) {
    const { t } = this.props;

    // let data = this.filterData(this.props.allData, this.props.filterColumnName, this.props.filterId);
    let data = this.props.data;

    let codes = [];
    let areas = [];
    let codesHash = {};

    for (let i = 0; i < data.length; i++) {
      let code = data[i].kod_1;
      let area = data[i].pov_1_ha;
      if (!codesHash[code]) {
        codes.push(code);
        areas.push(area);
        codesHash[code] = true;
      }
    }

    let res = "";

    for (let i = 0; i < codes.length; i++) {
      let c = codes[i]
      res += c + "xx - " + t("clc:" + c) + ": " + numbro(unit.transform(areas[i])).format() + " " + unit.short + ";   ";
    }
    return (<div>{res}</div>);
  }

  handleSort() {
    if (this.props.onSetSort) {
      this.props.onSetSort(!this.props.sort);
    }
  }

  handleSync() {
    if (this.props.onSetSync) {
      this.props.onSetSync();
    }
  }

  calcAxisYHigh(val) {
    let min = this.minY_ha || 1;
    let max = this.maxY_ha || 1;

    let exp = Math.log10(max);
    let step = exp / 9;

    let step_values = [12, 8, 7, 6, 5, 4, 3, 2, 1];
    step_values = step_values.map(x => Math.round(2 * min + (max / Math.exp(x * step))));

    let values = new Array();
    values.push(2 * min);
    values = values.concat(step_values);
    values.push(undefined);
    // console.log(values);

    let ord = (val / 10);

    return values[ord];
  }

  handleZoom(val) {
    if (this.props.onSetZoom) {
      this.props.onSetZoom(val);
    }
  }

  handleZoomMount(slider) {
    this.slider = slider;
  }

  _getTitle(data) {
    if (this.props.title && this.props.alwaysDefaultTitle) {
      return this.props.title;
    }
    if (data && data.length > 0) {
      let d = data[0];
      if (d.title_trans_token) {
        return this.props.t(d.title_trans_token);
      } else if (d.title) {
        return d.title;
      }
    } else {
      return null;
    }
  }

  render() {
    const { t, classes } = this.props;

    if (this.slider && this.props.zoom && this.slider.get() !== this.props.zoom) {
      this.slider.set(this.props.zoom);
    }
    return (
      <Context.Consumer>
        {ctx =>
          <Card>
            <CardHeader color={this.props.color}>
              <CardIcon color={this.props.color} style={{ height: "80px" }}>
                <Icon>signal_cellular_alt</Icon>
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {this._getTitle(this.props.data) || t("map:class-distribution")}
                <small> - {this.props.subtitle || t("map:level-3")}</small>
              </h4>
              <Typography className={classes.cardIconSubTitle}>{t('common:order')}: {this.props.sortType ? t('common:order-maxmin') : t('common:order-code')}
              </Typography>
            </CardHeader>
            <CardBody>
              <GridContainer spacing={0}>
                <GridItem xs={1}>
                  <GridContainer spacing={0}>
                    <GridItem xs={12} style={{ paddingBottom: "10px" }}>
                      <Tooltip title={t('common:change-order')}>
                        <Button onClick={this.handleSort} className={classNames("noUiChart-" + this.props.color, classes.white, classes.sizeTiny)} >
                          {this.props.sortType ? <ShortTextIcon /> : <BarChartIcon />}
                        </Button>
                      </Tooltip>
                    </GridItem>
                    <GridItem xs={12} style={{ height: "140px", paddingLeft: "15px" }}>
                      <CLCChartZoom
                        color={this.props.color}
                        val={this.props.zoom}
                        onSet={this.handleZoom}
                        onMount={this.handleZoomMount}
                      />
                    </GridItem>
                    {this.props.showSync ?
                      <GridItem xs={12} style={{ paddingTop: "10px" }} >
                        <Tooltip title={t('common:change-sync')}>
                          <Button onClick={this.handleSync} className={classNames("noUiChart-" + this.props.color, classes.white, classes.sizeTiny)}>
                            {this.props.sync ? <Sync /> : <SyncDisabled />}
                          </Button>
                        </Tooltip>
                      </GridItem>
                      : null}
                  </GridContainer>
                </GridItem>
                <GridItem xs={11} style={{ paddingLeft: "0px" }}>
                  <div id={this.props.id}>
                    <ChartistGraph
                      data={this.chartData(ctx.unit)}
                      type="Bar"
                      options={this.chartOptions(this.state.chart_width, ctx.unit)}
                      listener={this.chartListener()}
                    />
                  </div>
                </GridItem>
              </GridContainer>
            </CardBody>
            <CardFooter className={classes.cardFooter}>
              <small className={classes.cardFooter}>
                {this.footerData(ctx.unit)}
              </small>
            </CardFooter>
          </Card>
        }
      </Context.Consumer>
    );
  }
}

export default withNamespaces()(withStyles(dashGeneralPageStyle)(CLCDistChartCard));
